// extracted by mini-css-extract-plugin
export default {"container":"container-UC64iiGHAh6N","item1":"item1-QxenhSOqXBiV","item2":"item2-yfWNckQk11i4","item3":"item3-YddEWYLRyHrX"};